var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarklock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    transform: "translate(-970 -845)",
    fill: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -666,
    y: -143,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -190,
    y: -71,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#ECF3FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24,
    r: 18,
    fill: "#D1E2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2 22.4H30V18.8C30 16.16 27.84 14 25.2 14C22.56 14 20.4 16.16 20.4 18.8V22.4H19.2C18.6 22.4 18 23 18 23.6V32C18 32.6 18.6 33.2 19.2 33.2H31.2C31.8 33.2 32.4 32.6 32.4 32V23.6C32.4 23 31.8 22.4 31.2 22.4ZM26.4 30.8H24L24.48 28.16C23.88 27.92 23.4 27.2 23.4 26.6C23.4 25.64 24.24 24.8 25.2 24.8C26.16 24.8 27 25.64 27 26.6C27 27.32 26.64 27.92 25.92 28.16L26.4 30.8ZM27.6 22.4H22.8V18.8C22.8 17.48 23.88 16.4 25.2 16.4C26.52 16.4 27.6 17.48 27.6 18.8V22.4Z",
    fill: "#2C74D6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -189,
    y: -70,
    width: 427,
    height: 220,
    rx: 7,
    stroke: "#EAECF0",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    fill: "white",
    transform: "translate(-970 -845)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -666,
    y: -143,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -190,
    y: -71,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarklock);
export default "data:image/svg+xml,%3csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='48' height='48' fill='%23F5F5F5'/%3e %3cg clip-path='url(%23clip0_3916_412046)'%3e %3crect width='1440' height='1038' transform='translate(-970 -845)' fill='%23F9FAFC'/%3e %3cg clip-path='url(%23clip1_3916_412046)'%3e %3crect x='-666' y='-143' width='1457' height='318' rx='8' fill='white'/%3e %3cg clip-path='url(%23clip2_3916_412046)'%3e %3crect x='-190' y='-71' width='429' height='222' rx='8' fill='white'/%3e %3ccircle cx='24' cy='24' r='24' fill='%23ECF3FD'/%3e %3ccircle cx='25' cy='24' r='18' fill='%23D1E2FA'/%3e %3cpath d='M31.2 22.4H30V18.8C30 16.16 27.84 14 25.2 14C22.56 14 20.4 16.16 20.4 18.8V22.4H19.2C18.6 22.4 18 23 18 23.6V32C18 32.6 18.6 33.2 19.2 33.2H31.2C31.8 33.2 32.4 32.6 32.4 32V23.6C32.4 23 31.8 22.4 31.2 22.4ZM26.4 30.8H24L24.48 28.16C23.88 27.92 23.4 27.2 23.4 26.6C23.4 25.64 24.24 24.8 25.2 24.8C26.16 24.8 27 25.64 27 26.6C27 27.32 26.64 27.92 25.92 28.16L26.4 30.8ZM27.6 22.4H22.8V18.8C22.8 17.48 23.88 16.4 25.2 16.4C26.52 16.4 27.6 17.48 27.6 18.8V22.4Z' fill='%232C74D6'/%3e %3c/g%3e %3crect x='-189' y='-70' width='427' height='220' rx='7' stroke='%23EAECF0' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_3916_412046'%3e %3crect width='1440' height='1038' fill='white' transform='translate(-970 -845)'/%3e %3c/clipPath%3e %3cclipPath id='clip1_3916_412046'%3e %3crect x='-666' y='-143' width='1457' height='318' rx='8' fill='white'/%3e %3c/clipPath%3e %3cclipPath id='clip2_3916_412046'%3e %3crect x='-190' y='-71' width='429' height='222' rx='8' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };